let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6IFmc")).then(() => parcelRequire('jOGSG'));